"use strict";

var _license = require("../../../message/messageTypeDefinitions/license/license");
var _StandaloneMsgHandler = require("../../eventbus/StandaloneMsgHandler");
var _store = require("../../data/store");
(0, _StandaloneMsgHandler.registerStandaloneMsgHandler)(_license.REQUEST_GET_LICENSE, function (payload) {
  (0, _StandaloneMsgHandler.respondStandaloneRequest)(_license.RESPOND_LICENSE_DETAIL, (0, _store.getStandaloneDataStore)().license);
});